import { render, staticRenderFns } from "./EditorWrapper.vue?vue&type=template&id=5b321fcd&scoped=true&"
import script from "./EditorWrapper.vue?vue&type=script&lang=js&"
export * from "./EditorWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EditorWrapper.vue?vue&type=style&index=0&id=5b321fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b321fcd",
  null
  
)

component.options.__file = "EditorWrapper.vue"
export default component.exports